import {useProductCategoryList} from '@/hooks/useProductCategoryList'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useNavigate, useParams} from 'react-router-dom'

export const useBaseDataEditHook = ({onDataChange}) => {
  const {id} = useParams()
  const navigate = useNavigate()

  const baseDataFields = [
    {key: 'name', label: 'Display Name *', placeholder: 'Add Display Name', isDisabled: true},
    {key: 'productId', label: 'Product ID *', placeholder: '-', isDisabled: true},
    {key: 'parentId', label: 'Parent ID', placeholder: '-', isDisabled: true},
    {key: 'gtin', label: 'GTIN', placeholder: '-', isDisabled: true},
    {key: 'status', label: 'Status', type: 'dropdown', options: ['Active', 'Inactive', 'Draft'], isDisabled: true},
    {key: 'productSize', label: 'Product Size', placeholder: 'Add Product Size', isDisabled: true},
    {key: 'productType', label: 'Product Type', placeholder: 'Add Product Type', isDisabled: true},
    {key: 'segments', label: 'Store Segment', type: 'dropdown', options: ['Segments1', 'Segments2'], isMultiple: true},
    {key: 'skuNumber', label: 'SKU Number', placeholder: 'Add SKU Number'},
    {key: 'barCode', label: 'Bar Code', placeholder: 'Add Bar Code', isDisabled: true},
    {key: 'routeTypeId', label: 'Route Type ID', placeholder: 'Add Route Type ID'},
    {key: 'productLine', label: 'Product Line', placeholder: 'Add Product Line', isDisabled: true},
    {key: 'productGroup', label: 'Product Group', placeholder: 'Add Product Group', isDisabled: true},
    {key: 'productContainer', label: 'Product Container', placeholder: 'Add Product Container', isDisabled: true},
    {key: 'saleUom', label: 'Sale Unit Name', placeholder: 'Add Sale Unit Name', isDisabled: true},
    {key: 'allowedInMultiplesOf', label: 'Multiple Selling Units', placeholder: 'Add Multiple Selling Units'},
    {
      key: 'suggestedSellingPrice',
      label: 'Suggested Product Selling Price',
      placeholder: 'Add Suggested Product Selling Price',
    },
    {key: 'sorting', label: 'Sorting', placeholder: 'Add Sorting', type: 'number'},
    {key: 'showOnEcommerce', label: 'Show on e-commerce', type: 'toggle', className: 'toggle-alignment'},
    {key: 'showOnEngagement', label: 'Show on engagement', type: 'toggle', className: 'toggle-alignment'},
    {
      key: 'productDescription',
      label: 'Product Description',
      placeholder: 'Add Product Description',
      isMultilingual: true,
      isDisabled: true,
    },
    {
      key: 'sizeByLocale',
      label: 'Display Product Size',
      placeholder: 'Add Display Product Size',
      isMultilingual: true,
      isDisabled: false,
      isIdShown: true,
      id: 'sizeId',
      isRequired: true,
    },
    {
      key: 'productTypeByLocale',
      label: 'Display Product Type',
      placeholder: 'Add Display Product Type',
      isMultilingual: true,
      isDisabled: false,
      isIdShown: true,
      id: 'productTypeId',
      isRequired: true,
    },
  ]

  const additionaInfoFields = [
    {key: 'displayProductSize', label: 'Product Size', placeholder: 'Add Product Size'},
    {key: 'productCode2', label: 'Product Code 2', placeholder: 'Add Product Code', isDisabled: true},
    {key: 'gtmuId', label: 'GMTU', placeholder: 'Add GMTU', isDisabled: true},
    {key: 'salesOrg', label: 'Sales Org', placeholder: 'Add Sales Org', isDisabled: true},
    {key: 'packageName', label: 'Package Name', placeholder: 'Add Package Name', isDisabled: true},
    {key: 'packageCode', label: 'Package', placeholder: 'Add Package', isDisabled: true},
    {
      key: 'distributionChannel',
      label: 'Distribution Channel',
      placeholder: 'Add Distribution Channel',
      isDisabled: true,
    },
    {key: 'displayOrder', label: 'Display Order', placeholder: 'Add Display Order'},
    {
      key: 'maximumOrderQuantity',
      label: 'Maximum Order Quantity',
      placeholder: 'Add Maximum Order Quantity',
      type: 'number',
    },
    {
      key: 'minimumOrderQuantity',
      label: 'Minimum Order Quantity',
      placeholder: 'Add Minimum Order Quantity',
      type: 'number',
    },

    {key: 'unitMultiplier', label: 'Unit Multiplier', placeholder: 'Add Unit Multiplier'},
    {key: 'wishlist', label: 'Wishlist', placeholder: 'Add Wishlist'},
    {key: 'rewardPoints', label: 'Reward Points', placeholder: 'Add Reward Points'},
    {
      key: 'returnPriceForBaseUnit',
      label: 'Return Price For Base Unit',
      placeholder: 'Add Return Price For Base Unit',
      type: 'number',
    },
    {
      key: 'saleUnitConversionToBase',
      label: 'Sale Unit Conversion To Base',
      placeholder: 'Add Sale Unit Conversion To Base',
      type: 'number',
      isDisabled: true,
    },
  ]

  const handleCancel = () => {
    navigate(ROUTES.PRODUCT_REVIEW.replace(':id', id), {state: {selectedTabNumb: 0}})
  }

  const handleFormChange = data => {
    onDataChange(data)
  }

  // Category list data
  const {categoryListData} = useProductCategoryList()

  return {
    baseDataFields,
    categoryListData,
    handleFormChange,
    additionaInfoFields,
    handleCancel,
  }
}
